<template>
    <div style="position: fixed;top:0px;left:0px;right: 0px;bottom: 0px;overflow: hidden">
        <div style="margin-top:50px"></div>
        <el-tabs type="border-card" >
            <el-tab-pane label="預約資料">
                <div :style="{'height':curHeight+'px','overflow': 'auto'}">
                    <mt-field class="import" label="預約日期" placeholder="預約日期" type="date" v-model="overseaApplication.mcvDate"></mt-field>
                    <mt-field class="import" label="預約時間" placeholder="預約時間" type="time"  v-model="overseaApplication.mcvTime"></mt-field>
                    <mt-cell class="import" title="合作夥伴"  >
                        <div >{{partnerName}}</div>
                    </mt-cell>
                    <mt-field label="會面地址" placeholder="會面地址" type="text" v-model="overseaApplication.meetAddress"></mt-field>
                    <mt-field label="陪同人" placeholder="陪同人" type="text"  v-model="overseaApplication.partnerAdmin"></mt-field>
                    <mt-field label="陪同人電話" placeholder="陪同人電話" type="tel"  v-model="overseaApplication.partnerMobile"></mt-field>
                    <mt-cell class="import" title="是否驗身" is-link @click.native="isMedicalVisible=true" >
                        <div style="margin-right:2.8rem">{{isMedical==''?'請選擇':isMedical}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%;"
                            v-model="isMedicalVisible"
                            position="bottom">

                        <div style="text-align: right"><mt-button size="small" @click="isMedicalVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="isMedicalSlots" @change="isMedicalChange" ></mt-picker>


                    </mt-popup>

                    <mt-cell class="import" title="地區" >
                        <div style="margin-right:2.8rem">香港</div>
                    </mt-cell>

                    <div style="background: #000;position: fixed;top:0px;left:0px;right:0px;bottom: 0px;z-index:300;opacity: 0.5;" v-if="popupVisible" @click="popupVisible=false">
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="產品資料">
                <div :style="{'height':curHeight+'px','overflow': 'auto'}">
                    <div>
                        <mt-cell class="import" title="保險公司" is-link @click.native="insuranceVisible=true" >
                            <div >{{insuranceName==''?'請選擇':insuranceName}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="insuranceVisible"
                                position="bottom">
                            <div style="text-align: right"><mt-button size="small" @click="insuranceVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="insuranceSolts" @change="onInsuranceChange" ></mt-picker>
                        </mt-popup>
                        <mt-cell class="import" title="主計畫" is-link @click.native="overseaAppVisible=true" >
                            <div  >{{overseaAppName==''?'請選擇':overseaAppName}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="overseaAppVisible"
                                position="bottom">
                            <div style="text-align: right"><mt-button size="small" @click="overseaAppVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="overseaAppSolts" @change="onOverseaAppChange" ></mt-picker>

                        </mt-popup>
                        <mt-cell class="import" title="計畫年期" is-link @click.native="riderVisible=true" >
                            <div >{{riderName==''?'請選擇':riderName}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="riderVisible"
                                position="bottom">
                            <div style="text-align: right"><mt-button size="small" @click="riderVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="riderSolts" @change="onRiderChange" ></mt-picker>

                        </mt-popup>
                        <mt-cell class="import" title="貨幣" is-link @click.native="currencyVisible=true" >
                            <div >{{currencyName==''?'請選擇':currencyName}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="currencyVisible"
                                position="bottom">
                            <div style="text-align: right"><mt-button size="small" @click="currencyVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="currencySolts" @change="onCurrencyChange" ></mt-picker>
                        </mt-popup>
                        <mt-field label="保額" v-model="overseaApplication.sumInsured" placeholder="保額" type="number" ></mt-field>
                        <mt-field label="保費" v-model="overseaApplication.premium" placeholder="保費" type="number" ></mt-field>
                        <div style="position: fixed;top:0px;bottom: 0px;left:0px;right:0px;background:rgba(3,3,3,0.1);z-index:222" v-if="productVisible" @click="productVisible=false"></div>
                        <div style="position: fixed;top:0px;bottom: 0px;left:0px;right:0px;background:rgba(3,3,3,0.1);z-index:222" v-if="productPeriodVisible" @click="productPeriodVisible=false"></div>
                        <div style="position: relative;">
                            <mt-cell style="padding:0px 0px 0px 20px" title=" "  >
                            </mt-cell>
                            <i class="iconfont icon-jia" @click="createOverseaRider"  ></i>
                            <span style="color: black;font-size:15px;position: absolute;top: 15px;left: 32px;"  @click="createOverseaRider" >附加計劃</span>
                            <div             v-for="(val,index) in overseaApplication.overseaRiderList"  :key="index"  v-if=" overseaApplication.overseaRiderList.length!=0">

                                <mt-cell  :title="'附加計劃'+(index+1)" @click.native="changeCollsapce(index)" >
                                    <i class="iconfont icon-youjiantou-copy" :style="{'transform':styleList[index]==false?'rotate(0deg)':'rotate(90deg)','transition':'all 0.5s'}"></i>
                                </mt-cell>
                                <div :class="styleList[index]==false?'collsapce':'cell'">
                                    <mt-cell title="產品" is-link @click.native="productVisible=true;currencyOverseaRiderIndex = index;" >
                                        <div v-if="val.name!=null">{{val.name==''?'請選擇':val.name}}</div>
                                    </mt-cell>
                                    <mt-popup
                                            style="width:100%"
                                            v-model="productVisible"
                                            position="bottom">

                                        <div style="text-align: right"><mt-button size="small" @click="productVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                                        <mt-picker :slots="val.productSolts"   @change="onProductChange" ></mt-picker>
                                    </mt-popup>

                                    <mt-cell title="年期" is-link @click.native="productPeriodVisible=true;currencyOverseaRiderIndex = index;" >
                                        <div v-if="val.riderName!=null">{{val.riderName==''?'請選擇':val.riderName}}</div>
                                    </mt-cell>
                                    <mt-popup
                                            style="width:100%"
                                            v-model="productPeriodVisible"
                                            position="bottom">
                                        <div style="text-align: right"><mt-button size="small" @click="productPeriodVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                                        <mt-picker :slots="val.productPeriodSolts" @change="onRiderChange2" ></mt-picker>
                                    </mt-popup>

                                    <mt-field label="保額" placeholder="保額" type="number"  v-model="val.sumInsured"></mt-field>
                                    <mt-field label="保費" placeholder="保費" type="number"  v-model="val.premium"></mt-field>

                                    <mt-button type="default" size="large" @click="delOverseaRider();currencyOverseaRiderIndex = index;"><i class="el-icon-delete"></i>刪除</mt-button>
                                </div>
                            </div>
                        </div>
                        <mt-field label="附加計畫" v-model="pdfName2" placeholder="保額" type="text"  v-if="pdfName2!=null&&pdfName2!=''" ></mt-field>
                        <mt-field label="保額" v-model="overseaApplication.tableName2Insured" placeholder="保額" v-if="pdfName2!=null&&pdfName2!=''" type="number" ></mt-field>
                        <mt-field label="附加計畫" v-model="pdfName3" placeholder="保額" type="text"  v-if="pdfName3!=null&&pdfName3!=''" ></mt-field>
                        <mt-field label="保額" v-model="overseaApplication.tableName3Insured" placeholder="保額" v-if="pdfName3!=null&&pdfName3!=''" type="number" ></mt-field>
                        <mt-cell class="import" title="繳費模式" is-link @click.native="payTermVisible=true" >
                            <div >{{payTermName==''?'請選擇':payTermName}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="payTermVisible"
                                position="bottom">
                            <div style="text-align: right"><mt-button size="small" @click="payTermVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="payTermSolts"  @change="onPayTermChange" ></mt-picker>
                        </mt-popup>
                        <mt-field label="追溯日期" placeholder="追溯日期" type="date" ></mt-field>
                        <mt-cell title="投保人保障">
                            <span style="margin-right:2.8rem"><mt-switch  v-model="overseaApplication.dateBack"></mt-switch></span>
                        </mt-cell>
                        <mt-field label="供款年期" placeholder="供款年期" type="text"  ></mt-field>
                        <mt-cell title="保單貸款"  class="import">
                            <span style="margin-right:2.8rem"><mt-switch v-model="isLoan" @change="getisLoan"></mt-switch></span>
                        </mt-cell>
                    </div>

                </div>
            </el-tab-pane>
            <el-tab-pane label="被保人資料">
                <div :style="{'height':curHeight+'px','overflow': 'auto'}">
                    <mt-field label="中文姓名" placeholder="中文姓名" type="text"  v-model="overseaApplication.insuredNameChi"></mt-field>
                    <mt-field label="英文姓名" placeholder="英文姓名" type="text" v-model="overseaApplication.insuredNameEng"></mt-field>
                    <mt-field label="出生日期" placeholder="出生日期" type="date"   v-model="overseaApplication.insuredDob"></mt-field>
                    <mt-cell title="婚姻狀態" class="import" is-link @click.native="maritalVisible=true" >
                        <div >{{maritalName==''?'請選擇':maritalName}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="maritalVisible"
                            position="bottom">
                        <!--                        <div>fdfew</div>-->
                        <div style="text-align: right"><mt-button size="small" @click="maritalVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="maritalSlots" @change="onMaritalChange" ></mt-picker>


                    </mt-popup>
                    <mt-cell title="香港居民" class="import" is-link @click.native="IsHkVisible=true" >
                        <div >{{insuredIsHk==''?'請選擇':insuredIsHk}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="IsHkVisible"
                            position="bottom">
                        <div style="text-align: right"><mt-button size="small" @click="IsHkVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="IsHkSlots" @change="onIsHkChange" ></mt-picker>

                    </mt-popup>
                    <mt-field label="國籍" placeholder="國籍" type="text" v-model="overseaApplication.insuredCountry"></mt-field>
                    <mt-cell title="是否美國國籍" class="import" is-link @click.native="insuredIsUsVisible=true" >
                        <div >{{insuredIsUs==''?'請選擇':insuredIsUs}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="insuredIsUsVisible"
                            position="bottom">
                        <div style="text-align: right"><mt-button size="small" @click="insuredIsUsVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="insuredIsUsSlots" @change="oninsuredIsUsChange" ></mt-picker>

                    </mt-popup>
                    <mt-field label="身份證號碼" placeholder="身份證號碼" v-model="overseaApplication.insuredIdNo" type="number" ></mt-field>
                    <mt-field label="有效期至" placeholder="有效期至" type="date"  v-model="overseaApplication.insuredIdNoDate" ></mt-field>
                    <mt-cell title="教育程度" is-link @click.native="educationVisible=true" >
                        <div >{{education==''?'請選擇':education}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="educationVisible"
                            position="bottom">
                        <!--                        <div>fdfew</div>-->
                        <div style="text-align: right"><mt-button size="small" @click="educationVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="educationSlots" @change="onEducationChange" ></mt-picker>

                        <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                    </mt-popup>
                    <mt-field label="護照號碼" placeholder="護照號碼" type="number"  v-model="overseaApplication.insuredPassport" ></mt-field>
                    <mt-field label="有效期至" placeholder="有效期至" type="date" v-model="overseaApplication.insuredPassportDate" ></mt-field>
                    <!--                <mt-cell  class="import" title="性別" is-link  >-->
                    <!--&lt;!&ndash;                    <div style="margin-right:2.8rem">{{value2==''?'請選擇':value2}}</div>&ndash;&gt;-->
                    <!--                </mt-cell>-->
                    <mt-cell title="性別" class="import" is-link @click.native="insuredSexVisible=true" >
                        <div >{{insuredSex==''?'請選擇':insuredSex}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="insuredSexVisible"
                            position="bottom">
                        <!--                        <div>fdfew</div>-->
                        <div style="text-align: right"><mt-button size="small" @click="insuredSexVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="insuredSexSlots" @change="onInsuredSexChange" ></mt-picker>

                        <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                    </mt-popup>
                    <mt-field  label="年齡" placeholder="年齡" type="number"  v-model="overseaApplication.insuredAge" ></mt-field>

                    <mt-field   label=" 電郵" placeholder=" 電郵" type="number" v-model="overseaApplication.insuredEmail"></mt-field>
                    <mt-field   label="  電話(流動)" placeholder="電話(流動)" type="number" v-model="overseaApplication.insuredMobile"></mt-field>
                    <mt-field   label="電話(單位)" placeholder="電話(單位)" type="text"  v-model="overseaApplication.insuredMobileCpy"></mt-field>
                    <mt-field   label=" 電話(住所)" placeholder="電話(住所)" type="text" v-model="overseaApplication.insuredMobileHome"></mt-field>
                    <mt-field   label="住宅地址/身份證地址" placeholder="" type="text"  v-model="overseaApplication.insuredIdAddress" ></mt-field>
                    <mt-field   label="通訊地址" placeholder="通訊地址" type="text" v-model="overseaApplication.insuredCorAddress"></mt-field>
                    <mt-field   label="公司名稱" placeholder="公司名稱" type="text" v-model="overseaApplication.insuredCpy"></mt-field>
                    <mt-field   label="業務性質" placeholder="業務性質" type="text"  v-model="overseaApplication.insuredBusinessNature"></mt-field>
                    <mt-field   label="職位" placeholder="職位" type="text" v-model="overseaApplication.insuredPosition"></mt-field>
                    <mt-field   label=" 主要職務" placeholder="主要職務" type="text" v-model="overseaApplication.insuredDuty" ></mt-field>
                    <mt-field label=" 公司地址" placeholder="公司地址" type="text"  v-model="overseaApplication.insuredCpyAddress" ></mt-field>
                    <mt-field  label=" 每月收入" placeholder="" type="number" v-model="overseaApplication.insuredIncome" ></mt-field>
                    <mt-field  label="每月支出" placeholder="" type="number" v-model="overseaApplication.insuredExpense" ></mt-field>
                    <mt-field  label="固定資產" placeholder="" type="number" v-model="overseaApplication.insuredFixedAsset"></mt-field>
                    <mt-field  label=" 流動資產" placeholder="" type="number" v-model="overseaApplication.insuredLiquidAsset"></mt-field>
                    <mt-field  label="總負債" placeholder="" type="number" v-model="overseaApplication.insuredLiability"></mt-field>
                    <mt-field  label="退休年齡" placeholder="" type="number" v-model="overseaApplication.insuredRetiredAge"></mt-field>
                    <mt-field  label="供養家庭成員" placeholder="" type="number" v-model="overseaApplication.insuredFamily"></mt-field>
                    <mt-field  label="身高cm" placeholder="" type="number" v-model="overseaApplication.insuredHeight"></mt-field>
                    <mt-field  label="體重kg" placeholder="" type="number" v-model="overseaApplication.insuredWeight"></mt-field>
                    <mt-cell title="是否吸煙"   class="import">
                        <el-radio-group v-model="overseaApplication.insuredIsSmoke" size="mini" style="width:170px;" >
                            <el-radio-button label="1">是</el-radio-button>
                            <el-radio-button label="0">否</el-radio-button>
                        </el-radio-group>
                    </mt-cell>
                    <div style="position: fixed;top:0px;bottom: 0px;left:0px;right:0px;background:rgba(3,3,3,0.1);z-index:222" v-if="familyHealthVisible" @click="familyHealthVisible=false"></div>
                    <mt-cell title="家庭成員健康狀況" is-link @click.native="familyHealthVisible=true" class="import" >
                        <div >{{FamilyHealth==''?'請選擇':FamilyHealth}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="familyHealthVisible"
                            position="bottom">
                        <div style="text-align: right"><mt-button size="small" @click="familyHealthVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="familyHealthSlots" @change="onFamilyHealthChange" ></mt-picker>

                    </mt-popup>
                    <div style="position: fixed;top:0px;bottom: 0px;left:0px;right:0px;background:rgba(3,3,3,0.1);z-index:222" v-if="PersonalHealthVisible" @click="PersonalHealthVisible=false"></div>
                    <mt-cell title="個人健康狀況" is-link @click.native="PersonalHealthVisible=true" class="import">
                        <div >{{PersonalHealth==''?'請選擇':PersonalHealth}}</div>
                    </mt-cell>
                    <mt-popup
                            style="width:100%"
                            v-model="PersonalHealthVisible"
                            position="bottom">
                        <div style="text-align: right"><mt-button size="small" @click="PersonalHealthVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                        <mt-picker :slots="PersonalHealthSlots" @change="onPersonalHealthChange" ></mt-picker>
                    </mt-popup>
                    <mt-cell title="在過去五年內, 是否曾因任何原因而接受身體檢查:"  class="import">
                        <el-radio-group v-model="overseaApplication.insuredMedicalHist" size="mini" style="width:100px;">
                            <el-radio-button label="1">有</el-radio-button>
                            <el-radio-button label="0">沒有</el-radio-button>
                        </el-radio-group>
                    </mt-cell>
                    <mt-cell title=" 在過去五年內, 你是否曾因任何原因而入住入醫:"   class="import">
                        <el-radio-group v-model="overseaApplication.insuredHospitalHist" size="mini" style="width:100px;">
                            <el-radio-button label="1">有</el-radio-button>
                            <el-radio-button label="0">沒有</el-radio-button>
                        </el-radio-group>
                    </mt-cell>
                    <mt-cell title="是否正在長期服用藥物或接受治療:"   class="import">
                        <el-radio-group v-model="overseaApplication.insuredTreatment" size="mini" style="width:100px;">
                            <el-radio-button label="1">有</el-radio-button>
                            <el-radio-button label="0">沒有</el-radio-button>
                        </el-radio-group>

                    </mt-cell>
                    <mt-field  label="備註" placeholder="" type="text"></mt-field>
                </div>
            </el-tab-pane>
            <el-tab-pane label="投保人資料">
                <div  :style="{'height':curHeight+'px','overflow': 'auto'}">

                    <label>若被保人與持有人不為相同人士, 請在空格打勾</label>
                    <input type="checkbox" id="checkAll" v-model="overseaApplication.insuredAsOwner">
                    <div  v-if="overseaApplication.insuredAsOwner">
                        <mt-field label="中文姓名" placeholder="中文姓名" type="text" v-model="overseaApplication.ownerNameChi"></mt-field>
                        <mt-field label="英文姓名" placeholder="英文姓名" type="text"  v-model="overseaApplication.ownerNameEng"></mt-field>
                        <mt-field label="出生日期" placeholder="出生日期" type="date"  v-model="overseaApplication.ownerDob"></mt-field>
                        <mt-cell class="import" title="婚姻狀態" is-link @click.native="maritalVisible=true" >
                            <div >{{ownerMarital==''?'請選擇':ownerMarital}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="maritalVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="maritalVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="maritalSlots" @change="onOwnerMaritalChange" ></mt-picker>

                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>
                        <mt-cell class="import" title="香港居民" is-link @click.native="IsHkVisible=true" >
                            <div >{{ownerIsHk==''?'請選擇':ownerIsHk}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="IsHkVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="IsHkVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="IsHkSlots" @change="onOwnerIsHkChange" ></mt-picker>

                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>
                        <mt-field label="國籍" placeholder="國籍" type="text" v-model="overseaApplication.ownerCountry" ></mt-field>
                        <mt-cell class="import" title="是否美國國籍" is-link @click.native="insuredIsUsVisible=true" >
                            <div >{{ownerIsUs==''?'請選擇':ownerIsUs}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="insuredIsUsVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="insuredIsUsVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="insuredIsUsSlots" @change="onOwnerIsUsChange" ></mt-picker>

                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>

                        <mt-field label="身份證號碼" placeholder="身份證號碼" type="number" v-model="overseaApplication.ownerIdNo"></mt-field>
                        <mt-field label="身份證號碼" placeholder="身份證號碼" type="number" v-model="overseaApplication.ownerIdNo"></mt-field>
                        <mt-field label="有效期至" placeholder="有效期至" type="date" v-model="overseaApplication.ownerIdNoDate"></mt-field>
                        <mt-field label="與被保人關係" placeholder="與被保人關係" type="text" v-model="overseaApplication.relationship"></mt-field>

                        <mt-field label="護照號碼" placeholder="護照號碼" type="number" v-model="overseaApplication.ownerPassport" ></mt-field>
                        <mt-field label="有效期至" placeholder="有效期至" type="date"  v-model="overseaApplication.ownerPassportDate" ></mt-field>
                        <mt-cell title="教育程度" is-link @click.native="educationVisible=true" >
                            <div >{{ownerEducation==''?'請選擇':ownerEducation}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="educationVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="educationVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="educationSlots" @change="onOwnerEducationChange" ></mt-picker>

                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>
                        <mt-cell title="性別" is-link @click.native="insuredSexVisible=true" class="import">
                            <div >{{ownerSex==''?'請選擇':ownerSex}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="insuredSexVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="insuredSexVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="insuredSexSlots" @change="onOwnerSexChange" ></mt-picker>

                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>
                        <mt-field class="import" label="年齡" placeholder="年齡"  v-model="overseaApplication.ownerAge"  type="number" ></mt-field>
                        <mt-field   label=" 電郵" placeholder=" 電郵" type="number" v-model="overseaApplication.ownerEmail"></mt-field>
                        <mt-field   label="  電話(流動)" placeholder="  電話" type="number" v-model="overseaApplication.ownerMobile"></mt-field>
                        <mt-field   label="電話(單位)" placeholder="" type="number"  v-model="overseaApplication.ownerMobileCpy"></mt-field>
                        <mt-field   label=" 電話(住所)" placeholder="" type="number" v-model="overseaApplication.ownerMobileHome" ></mt-field>
                        <mt-field   label="住宅地址/身份證地址" placeholder="" type="text" v-model="overseaApplication.ownerIdAddress"></mt-field>
                        <mt-field   label="通訊地址" placeholder="通訊地址" type="text" v-model="overseaApplication.ownerCorAddress"></mt-field>
                        <mt-field   label="公司名稱" placeholder="公司名稱" type="text" v-model="overseaApplication.ownerCpy"></mt-field>
                        <mt-field   label="業務性質" placeholder="業務性質" type="text" v-model="overseaApplication.ownerBusinessNature"></mt-field>
                        <mt-field   label="職位" placeholder="職位" type="text" v-model="overseaApplication.ownerPosition"></mt-field>
                        <mt-field   label=" 主要職務" placeholder="主要職務" type="text"  v-model="overseaApplication.ownerDuty"></mt-field>
                        <mt-field label=" 公司地址" placeholder="公司地址" type="text" v-model="overseaApplication.ownerCpyAddress"></mt-field>
                        <mt-field  label=" 每月收入" placeholder="收入" type="number" v-model="overseaApplication.ownerIncome"></mt-field>
                        <mt-field  label="每月支出" placeholder="支出" type="number" v-model="overseaApplication.ownerExpense"></mt-field>
                        <mt-field  label="固定資產" placeholder="固定資產" type="number" v-model="overseaApplication.ownerFixedAsset"></mt-field>
                        <mt-field  label=" 流動資產" placeholder="流動資產" type="number" v-model="overseaApplication.ownerLiquidAsset"></mt-field>
                        <mt-field  label="總負債" placeholder="總負債" type="number" v-model="overseaApplication.ownerLiability"></mt-field>
                        <mt-field  label="退休年齡" placeholder="退休年齡" type="number" v-model="overseaApplication.ownerRetiredAge"></mt-field>
                        <mt-field  label="供養家庭成員" placeholder="供養家庭成員" type="number" v-model="overseaApplication.ownerFamily"></mt-field>
                        <mt-field  label="身高cm" placeholder="身高cm" type="number" v-model="overseaApplication.ownerHeight"></mt-field>
                        <mt-field  label="體重kg" placeholder="體重kg" type="number" v-model="overseaApplication.ownerWeight"></mt-field>
                        <mt-cell title="是否吸煙" class="import" >
                            <el-radio-group v-model="overseaApplication.ownerIsSmoke"  size="mini" style="width:170px;">
                                <el-radio-button label="1">是</el-radio-button>
                                <el-radio-button label="0">否</el-radio-button>
                            </el-radio-group>
                        </mt-cell>
                        <mt-cell title="家庭成員健康狀況" is-link @click.native="familyHealthVisible=true" class="import">
                            <div >{{ownerFamilyHealth==''?'請選擇':ownerFamilyHealth}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="familyHealthVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="familyHealthVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="familyHealthSlots" @change="onOwnerFamilyHealthChange" ></mt-picker>

                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>
                        <mt-cell title="個人健康狀況" is-link @click.native="PersonalHealthVisible=true" class="import">
                            <div >{{ownerPersonalHealth==''?'請選擇':ownerPersonalHealth}}</div>
                        </mt-cell>
                        <mt-popup
                                style="width:100%"
                                v-model="PersonalHealthVisible"
                                position="bottom">
                            <!--                        <div>fdfew</div>-->
                            <div style="text-align: right"><mt-button size="small" @click="PersonalHealthVisible=false" style="background: #00b3ee;color: #FFFFFF">確定</mt-button></div>
                            <mt-picker :slots="PersonalHealthSlots" @change="onOwnerPersonalHealthChange" ></mt-picker>
                            <!--                        <mt-picker  :slots="slots" value-key="name" @change="onValuesChange()"  ref="picker" v-model="value2"></mt-picker>-->
                        </mt-popup>
                        <mt-cell title="在過去五年內, 是否曾因任何原因而接受身體檢查:" class="import" >
                            <el-radio-group v-model="overseaApplication.ownerMedicalHist" size="mini" style="width:100px;">
                                <el-radio-button label="1">有</el-radio-button>
                                <el-radio-button label="0">沒有</el-radio-button>
                            </el-radio-group>
                        </mt-cell>
                        <mt-cell title=" 在過去五年內, 你是否曾因任何原因而入住入醫:"   class="import">
                            <el-radio-group v-model="overseaApplication.ownerHospitalHist" size="mini" style="width:100px;">
                                <el-radio-button label="1">有</el-radio-button>
                                <el-radio-button label="0">沒有</el-radio-button>
                            </el-radio-group>
                        </mt-cell>
                        <mt-cell title="是否正在長期服用藥物或接受治療:"   class="import">
                            <el-radio-group v-model="overseaApplication.ownerTreatment"  size="mini" style="width:100px;">
                                <el-radio-button label="1">有</el-radio-button>
                                <el-radio-button label="0">沒有</el-radio-button>
                            </el-radio-group>

                        </mt-cell>
                        <mt-field  label="備註" placeholder="" type="text" v-model="overseaApplication.ownerRemark"></mt-field>
                    </div>

                </div>

            </el-tab-pane>
            <el-tab-pane label="受益人資料">
                <div  :style="{'height':curHeight+'px','overflow': 'auto'}">
                    <div style="position: relative;">
                        <div  >
                            <mt-cell  title="受益人資料1" @click.native="changeCollsapce2(0)" >
                                <i class="iconfont icon-youjiantou-copy" :style="{'transform':styleList2[0]==false?'rotate(0deg)':'rotate(90deg)','transition':'all 0.5s'}"></i>
                            </mt-cell>
                            <div :class="styleList2[0]==false?'collsapce':'cell'">
                                <mt-field label="中文姓名" placeholder="產品" type="text"  v-model="overseaApplication.beneficiary1NameChi"></mt-field>
                                <mt-field label="英文姓名" placeholder="英文姓名" type="text" v-model="overseaApplication.beneficiary1NameEng"></mt-field>
                                <mt-field label="出生日期" placeholder="出生日期" type="date"   v-model="overseaApplication.beneficiary1Dob"></mt-field>
                                <mt-field label="性別" placeholder="性別" type="number" v-model="overseaApplication.beneficiary1Sex" ></mt-field>
                                <mt-field label="百分比" placeholder="百分比" type="number" v-model="overseaApplication.beneficiary1Rate" ></mt-field>
                                <mt-field label="與被保人關係" pleholder="與被保人關係" type="text"  v-model="overseaApplication.beneficiary1Relation"></mt-field>
                                <mt-field label="證件號碼" placeholder="證件號碼" type="text" v-model="overseaApplication.beneficiary1IdNo"></mt-field>
                            </div>
                        </div>
                        <div             >

                            <mt-cell title="受益人資料2"  @click.native="changeCollsapce2(1)" >
                                <i class="iconfont icon-youjiantou-copy" :style="{'transform':styleList2[1]==false?'rotate(0deg)':'rotate(90deg)','transition':'all 0.5s'}"></i>
                            </mt-cell>
                            <div :class="styleList2[1]==false?'collsapce':'cell'">
                                <mt-field label="中文姓名" placeholder="產品" type="text" v-model="overseaApplication.beneficiary2NameChi" ></mt-field>
                                <mt-field label="英文姓名" placeholder="英文姓名" type="text"  v-model="overseaApplication.beneficiary2NameEng"></mt-field>
                                <mt-field label="出生日期" placeholder="出生日期" type="date"  v-model="overseaApplication.beneficiary2Dob"></mt-field>
                                <mt-field label="性別" placeholder="性別" type="number" v-model="overseaApplication.beneficiary2Sex"></mt-field>
                                <mt-field label="百分比" placeholder="百分比" type="number" v-model="overseaApplication.beneficiary2Rate" ></mt-field>
                                <mt-field label="與被保人關係" pleholder="與被保人關係" type="text" v-model="overseaApplication.beneficiary2Relation" ></mt-field>
                                <mt-field label="證件號碼" placeholder="證件號碼" type="text" v-model="overseaApplication.beneficiary2IdNo"></mt-field>
                            </div>
                        </div>
                        <div   >

                            <mt-cell title="受益人資料3"   @click.native="changeCollsapce2(2)" >
                                <i class="iconfont icon-youjiantou-copy" :style="{'transform':styleList2[2]==false?'rotate(0deg)':'rotate(90deg)','transition':'all 0.5s'}"></i>
                            </mt-cell>
                            <div :class="styleList2[2]==false?'collsapce':'cell'">
                                <mt-field label="中文姓名" placeholder="產品" type="text" v-model="overseaApplication.beneficiary3NameChi"></mt-field>
                                <mt-field label="英文姓名" placeholder="英文姓名" type="text" v-model="overseaApplication.beneficiary3NameEng"></mt-field>
                                <mt-field label="出生日期" placeholder="出生日期" type="date"v-model="overseaApplication.beneficiary3Dob"></mt-field>
                                <mt-field label="性別" placeholder="性別" type="number" v-model="overseaApplication.beneficiary3Sex"></mt-field>
                                <mt-field label="百分比" placeholder="百分比" type="number" v-model="overseaApplication.beneficiary3Rate" ></mt-field>
                                <mt-field label="與被保人關係" pleholder="與被保人關係" type="text"v-model="overseaApplication.beneficiary3Relation" ></mt-field>
                                <mt-field label="證件號碼" placeholder="證件號碼" type="text" v-model="overseaApplication.beneficiary3IdNo" ></mt-field>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="其他資料" class="other_cls">
                <div  :style="{'height':curHeight+'px','overflow': 'auto'}">
                    <div class="other_box">
                        <p >財富來源:</p>
                        <div >
                            <el-checkbox v-model="overseaApplication.isSavings">儲蓄</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isSalaryIncome">受雇收入</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isSelfIncome">自雇收入</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isInvestIncome">投資收入</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isSaleOfAsset">出售資產</el-checkbox>
                            <el-checkbox v-model="overseaApplication.sourcesOther">其他</el-checkbox>
                        </div>
                    </div>
                    <div class="other_box">
                        <p >投保目的:</p>
                        <div >
                            <el-checkbox v-model="overseaApplication.isProtection">保障</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isEtFund">子女教育基金</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isSavingInvest">儲蓄及投資</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isRetirement">退休計劃</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isKeyMan">要員保險</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isEstate">遺產計劃</el-checkbox>
                            <el-checkbox v-model="overseaApplication.purposeOthers">其他</el-checkbox>

                        </div>
                    </div>
                    <div class="other_box">
                        <p>閣下是否於過去12個月內以這份投保申請書/建議書取代閣下任何現有壽險保單, 或取代任何現有壽險保單內大部份壽險成分?</p>

                        <div>
                            <el-checkbox v-model="overseaApplication.isProtection">是</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isEtFund">否</el-checkbox>
                        </div>
                    </div>
                    <div class="other_box">
                        <p>閣下是否打算於未來12個月內以這份投保申請書/建議書取代閣下任何現有壽險保單, 或取代任何現有壽險保單內大部份壽險成分?</p>
                        <div>
                            <el-checkbox v-model="overseaApplication.isProtection">是</el-checkbox>
                            <el-checkbox v-model="overseaApplication.isEtFund">否</el-checkbox>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="FNA資料">
                <div  :style="{'height':curHeight+'px','overflow': 'auto'}">
                    <div class="other_box" >
                        <p >目標:</p>
                        <div >
                            <el-checkbox-group v-model="overseaApplication.questionOne" disabled>
                                <el-checkbox v-for="choice in questionOneList"
                                             :label="choice.value" :key="choice.value">{{choice.label}}</el-checkbox>
                            </el-checkbox-group>
                            <el-input v-model="overseaApplication.questionOneName"  placeholder="" v-if="overseaApplication.questionOne.indexOf('6')>=0"
                                      auto-complete="off" style="width: 200px;position: absolute;right: 0px;top: 0px;right:-40px;"
                                      :minlength="0" :maxlength="50">
                            </el-input>
                        </div>
                    </div>
                    <div class="other_box">
                        <p >類型:</p>
                        <div >
                            <el-checkbox-group v-model="overseaApplication.questionTwo">
                                <el-checkbox v-for="choice in questionTwoList" disabled
                                             :label="choice.value" :key="choice.value">{{choice.label}}</el-checkbox>
                            </el-checkbox-group>
                            <el-input v-model="overseaApplication.questionTwoName"  placeholder="" v-if="overseaApplication.questionTwo.indexOf('5')>=0"
                                      auto-complete="off" style="width: 200px;position: absolute;right: 0px;top: 0px;right:-40px;"
                                      :minlength="0" :maxlength="50">
                            </el-input>
                        </div>
                    </div>
                    <div class="other_box">
                        <p>保障年期</p>

                        <div>
                            <el-radio-group v-model="overseaApplication.questionThree" disabled>
                                <el-radio v-for="choice in questionThreeList"
                                          :label="choice.value" :key="choice.value">{{choice.label}}</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="other_box">
                        <p>能夠及願意支付的年期為多少</p>
                        <div>
                            <el-radio-group v-model="overseaApplication.questionFourA" >
                                <el-radio :label="1" :key="1">< 1 年</el-radio>
                                <el-radio :label="2" :key="2">1 - 5 年</el-radio>
                                <el-radio :label="3" :key="3">6 - 10 年</el-radio>
                                <el-radio :label="4" :key="4">11 - 20 年</el-radio>
                                <el-radio :label="5" :key="5">> 20 年</el-radio>
                                <el-radio :label="6" :key="6">終身</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="other_box">
                        <p>佔閣下個人可動用收入的比率為多少?</p>
                        <div>
                            <el-radio-group v-model="overseaApplication.questionFourC">
                                <el-radio :label="1" :key="1"><10%</el-radio>
                                <el-radio :label="2" :key="2">10-20%</el-radio>
                                <el-radio :label="3" :key="3">21-30%</el-radio>
                                <el-radio :label="4" :key="4">31-40%</el-radio>
                                <el-radio :label="7" :key="7">41-50%</el-radio>
                                <el-radio :label="5" :key="5">>50%</el-radio>
                                <el-radio :label="6" :key="6"> N/A</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div  v-for="(item,k ) in fnaProductList" :key="k" style="color:#969696;border-bottom: 1px solid gray" class="content_text">
                        <div>
                            <p>種類</p><p><span v-if="item.isMain">主產品</span><span v-else>附加產品</span></p>
                        </div>
                        <div>
                            <p>產品</p><p>{{item.nameTw}}</p>
                        </div>
                        <div>
                            <p>問題1</p><p>{{item.questionOne}}</p>
                        </div>
                        <div>
                            <p>問題2</p><p>{{item.questionTwo}}</p>
                        </div>
                        <div>
                            <p>問題3</p><p>{{item.questionThree}}</p>
                        </div>
                        <div>
                            <p>選購產品</p><p><span v-if="item.isSelect">是</span><span v-else>否</span></p>
                        </div>
                    </div>
                </div>

            </el-tab-pane>
        </el-tabs>
        <mt-button size="large"  type="primary" @click="checkForm()">確定</mt-button>
    </div>
</template>
<script>
    import {queryProductByFnaAnswer,insertOverseaApplication,queryInsuranceOption,queryProductByInsuranceId,queryProductPeriodOption,queryCurrencyOption,updateOverseaApplication} from '../../api/api'
    export default {
        data(){
            return{
                curHeight:'',
                state:false,
                questionOneList:[
                    {label:'A',value:'1'},{label:'B',value:'2'},{label:'C',value:'3'},{label:'D',value:'4'}
                    ,{label:'E',value:'5'},{label:'F',value:'6'}
                ],
                questionTwoList:[
                    {label:'A',value:'1'},{label:'B',value:'2'},{label:'C',value:'3'},{label:'D',value:'4'}
                    ,{label:'E',value:'5'}
                ],
                questionThreeList:[
                    {label:'A',value:'1'},{label:'B',value:'2'},{label:'C',value:'3'},{label:'D',value:'4'}
                    ,{label:'E',value:'5'},{label:'F',value:'6'}
                ],
                isLoan:false,
                isMedical:'否',
                fnaProductList:[],
                ownerFamilyHealth:'',
                ownerPersonalHealth:'',
                ownerSex:'',
                ownerEducation:'',
                ownerIsUs:'',
                PersonalHealthSlots:[{values:['請選擇','健康','其他情況']}],
                PersonalHealthVisible:false,
                PersonalHealth:'',
                healthOption:[
                    {label:"健康",value:1},{label:"其他情況",value:0}
                ],
                familyHealthSlots:[{values:['請選擇','健康','其他情況']}],
                familyHealthVisible:false,
                FamilyHealth:'',
                insuredSexSlots:[{values:['請選擇','男','女']}],
                insuredSex :'',
                insuredSexVisible:false,
                educationVisible:false,
                education:'',
                educationSlots:[{values:["請選擇","小學","中學","大專或以上","大學","研究生","其他"]}],
                educationOption:[
                    {label:"小學",value:1},{label:"中學",value:2},{label:"大專或以上",value:3},
                    {label:"大學",value:4},{label:"研究生",value:5},{label:"其他",value:6}
                ],
                IsHkSlots:[{values:['請選擇','香港永久居民','非香港永久居民']}],
                insuredIsUsSlots:[{values:['請選擇','是','否']}],
                insuredIsUsVisible :false,
                insuredIsUs :'',
                IsHkVisible:false,
                ownerIsHk:'',
                maritalName:'',
                maritalSlots:[{values:['請選擇','單身','已婚','離婚','鰥寡']}],
                maritalVisible:false,
                maritalOption:[
                    {label:'單身',value:1},{label:'已婚',value:2},{label:'離婚',value:3},{label:'鰥寡',value:4}
                ],
                productPeriodVisible:false,
                productVisible:false,
                productSolts:[],
                productOption2:[],
                productNameList:[1,1,1,1,1],
                currencyOverseaRiderIndex:'',
                payTermOption:[ {label:'年繳',value:1},{label:'半年繳',value:2},{label:'季繳',value:3},{label:'月繳',value:4},{label:'一次性付清',value:5}],
                payTermSolts:[],
                payTermVisible:false,
                payTermName:'',
                currencySolts:[],
                currencyName:'',
                currencyVisible:false,
                riderName:'',
                riderSolts:[],
                riderVisible:false,
                overseaAppSolts:[],
                overseaAppName:'',
                overseaAppVisible:false,
                insuranceVisible:false,
                insuranceName:'',
                insuranceSolts:[],
                insuranceOption:[],
                partnerVisible:false,
                partnerOption:[],
                rightButtons : [
                    {
                        content: 'Mark as Unread',
                        style: { background: 'lightgray', color: '#fff' }
                    },
                    {
                        content: 'Delete',
                        style: { background: 'red', color: '#fff' },
                        handler: () => this.$messagebox('delete')
                    }
                ],
                ownerMarital:'',
                styleList2:[false,false,false],
                styleList:[],
                partnerName:'',
                overseaApplication:{
                    id:null,mcvDate:"",mcvTime:"",partnerId:this.$store.getters.staff.id,policyNo:"",insuranceId:"",meetAddress:"",partnerMobile:"",partnerAdmin:"",staffId:"",staffMobile:"",
                    productId:"",periodId:"",currencyId:"",premium:0,sumInsured:0,payTerm:"",productRider1:"",pr1SumInsured:"",productRider2:"",pr2SumInsured:"",
                    dateBack:"",isPb:0,insuredAsOwner:false,
                    insuredNameChi:"",insuredNameEng:"",insuredMarital:"",insuredCountry:"",insuredIdNo:"",insuredDob:"",insuredSex:"",insuredAge:0,
                    insuredMobileCpy:"",insuredMobileHome:"",insuredMobile:"",insuredEmail:"",insuredIdAddress:"",insuredCorAddress:"",insuredCpy:"",
                    insuredBusinessNature:"",insuredCpyAddress:"",insuredPosition:"",insuredDuty:"",insuredIncome:0,insuredExpense:0,insuredFixedAsset:0,
                    insuredLiquidAsset:0,insuredLiability:0,insuredRetiredAge:65,insuredFamily:0,insuredIsHk:"",insuredIdNoDate:"",insuredPassport:"",
                    insuredPassportDate:"",insuredHeight:0,insuredWeight:0,insuredIsSmoke:"",insuredPersonalHealth:"",insuredFamilyHealth:"",
                    insuredMedicalHist:"",insuredHospitalHist:"",insuredTreatment:"",insuredRemark:"",insuredIsUs:"",
                    ownerNameChi:"",ownerNameEng:"",ownerMarital:"",ownerCountry:"",ownerIdNo:"",ownerDob:"",ownerSex:"",ownerAge:"",
                    ownerMobileCpy:"",ownerMobileHome:"",ownerMobile:"",ownerEmail:"",ownerIdAddress:"",ownerCorAddress:"",ownerCpy:"",
                    ownerBusinessNature:"",ownerCpyAddress:"",ownerPosition:"",ownerDuty:"",ownerIncome:"",ownerExpense:"",ownerFixedAsset:"",
                    ownerLiquidAsset:"",ownerLiability:"",ownerRetiredAge:65,ownerFamily:"",ownerIsHk:"",ownerIdNoDate:"",ownerPassport:"",
                    ownerPassportDate:"",ownerHeight:"",ownerWeight:"",ownerIsSmoke:"",ownerPersonalHealth:"",ownerFamilyHealth:"",
                    ownerMedicalHist:"",ownerHospitalHist:"",ownerTreatment:"",ownerRemark:"",ownerIsUs:"",

                    beneficiary1NameChi:"",beneficiary1NameEng:"",beneficiary1Dob:"",beneficiary1Sex:"",beneficiary1Rate:0,beneficiary1Relation:"",
                    beneficiary1IdNo:"",
                    beneficiary2NameChi:"",beneficiary2NameEng:"",beneficiary2Dob:"",beneficiary2Sex:"",beneficiary2Rate:0,beneficiary2Relation:"",
                    beneficiary2IdNo:"",
                    beneficiary3NameChi:"",beneficiary3NameEng:"",beneficiary3Dob:"",beneficiary3Sex:"",beneficiary3Rate:0,beneficiary3Relation:"",
                    beneficiary3IdNo:"",

                    isMedical:0,isSavings:true,isSalaryIncome:true,isSelfIncome:"",isInvestIncome:"",isSaleOfAsset:"",sourcesOther:"",
                    isProtection:true,isEtFund:"",isSavingInvest:"",isRetirement:"",isKeyMan:"",isEstate:"",purposeOthers:"",declaration1:0,declaration2:0,
                    status:1,productOption:[],productPeriodOption:[],overseaRiderList:[],delOverseaRiderList:[],
                    remark:'',relationship:'',

                    questionOne:[],questionOneName:"",questionTwo:[],questionTwoName:"",questionThree:[],questionThreeName:"",
                    questionFourA:6,questionFourC:7,
                    fnaProductId1:"",fnaProductId2:"",fnaProductId3:"",fnaProductId4:"",fnaProductId5:"",fnaProductId6:"",fnaProductId7:"",
                    fnaCheckBox1:"",fnaCheckBox2:"",fnaCheckBox3:"",fnaCheckBox4:"",fnaCheckBox5:"",fnaCheckBox6:"",fnaCheckBox7:"",

                    insuredEducation:"",insuredEducationOther:"",ownerEducation:"",ownerEducationOther:"",year:"",isLoan:0,isTrust:0,
                    policyRegion:1
                },
                isMedicalVisible:false,
                isMedicalSlots:[{values:['否','是']}],
                insuredIsHk:'',
                pdfName2:'',
                pdfName3:'',
                dataList:[],
                currencyOption:[],
                value2:'',
                popupVisible:false,
                pickerValue:'',
                active:'tab-container1',
                value:false,
                partnerSlots:[],
                slots:
                    [
                        {
                            values: ['請選擇', '香港', '澳門']
                        }
                    ]
            }
        },
        mounted(){
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight
                    that.fullHeight = window.fullHeight
                })() }
            this.curHeight =document.documentElement.clientHeight-180
            // var mo=function(e){e.preventDefault();};
            // document.body.style.overflow='hidden';
            // document.addEventListener('touchmove',mo,false);
            this.queryPartnerOption()
            this.queryInsuranceOption()
            this.queryCurrencyOption();
            let datalist=[]
            this.payTermOption.filter(v=>{
                datalist.push(v.label)
            })
            this.payTermSolts.push({values:datalist})
            let data = JSON.parse(sessionStorage.getItem('overseaApplication'));
            let list= JSON.parse(sessionStorage.getItem('list'));
            if(data!=null&&data!=''&&data!=undefined&&JSON.stringify(this.overseaApplication)!=JSON.stringify(data)){
                this.$messagebox({
                    title: '溫馨提示',

                    message: '系統發現有未保存的資料, 按確定復恢, 取消鍵會清除有關記錄:',

                    showCancelButton: true,

                    confirmButtonText:"確定",

                    cancelButtonText:"取消"

                }).then(action => {
                    if(action == 'confirm'){
                        this.maritalName=list.maritalName
                        this.insuredIsHk=list.insuredIsHk
                        this.insuredIsUs=list.insuredIsUs
                        this. education =list.education
                        this.insuredSex =list.insuredSex
                        this.FamilyHealth=list.FamilyHealth
                        this.PersonalHealth=list.PersonalHealth
                        this.overseaApplication=data
                        this.insuranceName=list.insuranceName
                        this.overseaAppName=list.overseaAppName
                        this.partnerName=list.partnerName
                        this.isMedical=list.isMedical
                        this.value2=list.value2
                        this.riderName=list.riderName
                        this.currencyName=list.currencyName
                        this.payTermName=list.payTermName
                        this.ownerIsHk=list.ownerIsHk
                        this.ownerIsUs=list.ownerIsUs
                        this.ownerEducation=list.ownerEducation
                        this.ownerSex=list.ownerSex
                        this.ownerFamilyHealth=list.ownerFamilyHealth
                        this.ownerPersonalHealth=list.ownerPersonalHealth
                        this.PersonalHealthVisible=list.PersonalHealthVisible

                    }else{

                    }

                })
            }else {
                if(list!=null){
                    if(this.insuranceName!=list.insuranceName||this.overseaAppName!=list.overseaAppName||this.partnerName!=list.partnerName||this.isMedical!=list.isMedical||this.value2!=list.value2||this.currencyName!=list.currencyName||this.payTermName!=list.payTermName||this.ownerIsHk!=list.ownerIsHk||this.ownerIsUs!=list.ownerIsUs||this.ownerEducation!=list.ownerEducation||this.ownerSex!=list.ownerSex||this.ownerFamilyHealth!=list.ownerFamilyHealth||this.ownerPersonalHealth!=list.ownerPersonalHealth||this.PersonalHealthVisible!=list.PersonalHealthVisible){
                        this.$messagebox({
                            title: '溫馨提示',

                            message: '系統發現有未保存的資料, 按確定復恢, 取消鍵會清除有關記錄:',

                            showCancelButton: true,

                            confirmButtonText:"確定",

                            cancelButtonText:"取消"

                        }).then(action => {
                            if(action == 'confirm'){
                                this.riderName=list.this.riderName
                                this.maritalName=list.maritalName
                                this.insuredIsHk=list.insuredIsHk
                                this.insuredIsUs=list.insuredIsUs
                                this. education =list.education
                                this.insuredSex =list.insuredSex
                                this.FamilyHealth=list.FamilyHealth
                                this.PersonalHealth=list.PersonalHealth
                                this.overseaApplication=data
                                this.insuranceName=list.insuranceName
                                this.overseaAppName=list.overseaAppName
                                this.partnerName=list.partnerName
                                this.isMedical=list.isMedical
                                this.value2=list.value2
                                // this.riderName=list.riderName
                                this.currencyName=list.currencyName
                                this.payTermName=list.payTermName
                                this.ownerIsHk=list.ownerIsHk
                                this.ownerIsUs=list.ownerIsUs
                                this.ownerEducation=list.ownerEducation
                                this.ownerSex=list.ownerSex
                                this.ownerFamilyHealth=list.ownerFamilyHealth
                                this.ownerPersonalHealth=list.ownerPersonalHealth
                                this.PersonalHealthVisible=list.PersonalHealthVisible

                            }else{

                            }

                        })
                    }
                }

            }

        },
        beforeRouteLeave(to, form, next) {
            if(!this.state){
                sessionStorage.setItem('overseaApplication', JSON.stringify(this.overseaApplication))
                let list={partnerName:this.partnerName,isMedical:this.isMedical,value2:this.value2,riderName:this.riderName,currencyName:this.currencyName,payTermName:this.payTermName,
                    ownerIsHk:this.ownerIsHk,ownerIsUs:this.ownerIsUs,ownerEducation:this.ownerEducation,ownerSex:this.ownerSex,ownerFamilyHealth:this.ownerFamilyHealth,ownerPersonalHealth:this.ownerPersonalHealth,
                    PersonalHealthVisible:this.PersonalHealthVisible,insuranceName:this.insuranceName,overseaAppName:this.overseaAppName,maritalName:this.maritalName,insuredIsHk:this.insuredIsHk,insuredIsUs:this.insuredIsUs,
                    education:this.education,insuredSex:this.insuredSex,FamilyHealth:this.FamilyHealth,PersonalHealth:this.PersonalHealth
                }
                sessionStorage.setItem('list', JSON.stringify(list))
                next()
            }else {
                next()
            }

        },
        methods:{
            openMesg(){
                this.$toast({
                    message: '有未填妥項目',
                    position: 'center',
                    color:'red',
                    duration: 5000
                });
            },
            getisLoan(){
                if(this.isLoan){

                    this.overseaApplication.isLoan=1
                }else {
                    this.overseaApplication.isLoan=0
                }
            },
            fnaAnswerSelected(){
                this.fnaProductList=[];
                this.overseaApplication.questionOne=[];
                this.overseaApplication.questionTwo=[];
                this.overseaApplication.questionThree=[];
                this.overseaApplication.fnaProductId1=null;this.overseaApplication.fnaCheckBox1=null;
                this.overseaApplication.fnaProductId2=null;this.overseaApplication.fnaCheckBox2=null;
                this.overseaApplication.fnaProductId3=null;this.overseaApplication.fnaCheckBox3=null;
                this.overseaApplication.fnaProductId4=null;this.overseaApplication.fnaCheckBox4=null;
                this.overseaApplication.fnaProductId5=null;this.overseaApplication.fnaCheckBox5=null;
                this.overseaApplication.fnaProductId6=null;this.overseaApplication.fnaCheckBox6=null;
                this.overseaApplication.fnaProductId7=null;this.overseaApplication.fnaCheckBox7=null;
                if(this.overseaApplication.productId!=null && this.overseaApplication.productId!=''&&this.overseaApplication.productId!=undefined){
                    let mainProduct = this.overseaApplication.productOption.find(v=>v.id==this.overseaApplication.productId);
                    this.fnaAnswerLoop(mainProduct);
                    this.overseaApplication.questionThree = mainProduct.questionThree;
                    mainProduct.isMain=true;
                    mainProduct.isSelect=true;
                    this.overseaApplication.fnaCheckBox1=1;
                    this.fnaProductList.push(mainProduct);
                    this.overseaApplication.fnaProductId1 = mainProduct.id;
                    let params ={productId:mainProduct.id,questionOneList:mainProduct.questionOne,
                        questionTwoList:mainProduct.questionTwo,questionThree:mainProduct.questionThree}
                    queryProductByFnaAnswer(params).then(res=>{
                        if(res.errcode==200){
                            if(res.data!=null){
                                this.tempProduct = res.data;

                                this.tempProduct.isMain=true;
                                this.tempProduct.isSelect=false;
                                this.fnaProductList.push(this.tempProduct);
                                this.overseaApplication.fnaProductId2 = this.tempProduct.id;
                            };
                            this.overseaApplication.overseaRiderList.forEach((v,i)=>{
                                if(v.productId!=null && v.productId!=''&& v.productId!=undefined){
                                    let rider = v.productOption.find(y=>y.id==v.productId);
                                    this.fnaAnswerLoop(rider);
                                    rider.isMain=false;
                                    rider.isSelect=true;
                                    this.fnaProductList.push(rider);
                                    switch (i) {
                                        case 0:this.overseaApplication.fnaProductId3=rider.id;this.overseaApplication.fnaCheckBox3=1;break;
                                        case 1:this.overseaApplication.fnaProductId4=rider.id;this.overseaApplication.fnaCheckBox4=1;break;
                                        case 2:this.overseaApplication.fnaProductId5=rider.id;this.overseaApplication.fnaCheckBox5=1;break;
                                        case 3:this.overseaApplication.fnaProductId6=rider.id;this.overseaApplication.fnaCheckBox6=1;break;
                                        case 4:this.overseaApplication.fnaProductId7=rider.id;this.overseaApplication.fnaCheckBox7=1;break;
                                    }
                                }
                            });
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductByFnaAnswer Error");
                    });
                }

            },
            fnaAnswerLoop(obj){
                if(obj.questionOne!=null&&obj.questionOne!=''&&obj.questionOne!=undefined){
                    let list = obj.questionOne.split(",");
                    list.forEach(v=>{
                        if(this.overseaApplication.questionOne!=null && this.overseaApplication.questionOne!=undefined &&
                            this.overseaApplication.questionOne!=""){
                            let isNew=false;
                            for(let i=0;i<this.overseaApplication.questionOne.length;i++){
                                if(this.overseaApplication.questionOne[i]==v){
                                    isNew=false
                                }else{
                                    isNew=true;
                                }
                            }
                            if(isNew){
                                this.overseaApplication.questionOne.push(v);
                            }
                        }
                        this.overseaApplication.questionOne.push(v);
                    });
                }
                if(obj.questionTwo!=null&&obj.questionTwo!=''&&obj.questionTwo!=undefined){
                    let list = obj.questionTwo.split(",");
                    list.forEach(v=>{
                        if(this.overseaApplication.questionTwo!=null && this.overseaApplication.questionTwo!=undefined &&
                            this.overseaApplication.questionTwo!=""){
                            let isNew=false;
                            for(let i=0;i<this.overseaApplication.questionTwo.length;i++){
                                if(this.overseaApplication.questionTwo[i]==v){
                                    isNew=false
                                }else{
                                    isNew=true;
                                }
                            }
                            if(isNew){
                                this.overseaApplication.questionTwo.push(v);
                            }
                        }
                        this.overseaApplication.questionTwo.push(v);
                    })

                }



            },
            overseaApplicationSave(ev){
                if(this.overseaApplication.id=="" || this.overseaApplication.id==null){
                    let params=Object.assign({},this.overseaApplication);
                    var date = new Date(params.mcvDate);
                    params.mcvDate= Date.parse(date)
                    params.mcvDate = params.mcvDate / 1000;
                    if(params.dateBack!=null&&params.dateBack!=''&&params.dateBack!=undefined){
                        var date1 = new Date(params.dateBack);
                        params.dateBack= Date.parse(date1)
                        params.dateBack = params.dateBack / 1000;
                    }
                    if(params.insuredIdNoDate!=null&&params.insuredIdNoDate!=''&&params.insuredIdNoDate!=undefined){
                        var date6 = new Date(params.insuredIdNoDate);
                        params.insuredIdNoDate= Date.parse(date6)
                        params.insuredIdNoDate = params.insuredIdNoDate / 1000;
                    }
                    if(params.insuredPassportDate!=null&&params.insuredPassportDate!=''&&params.insuredPassportDate!=undefined){
                        var date5 = new Date(params.insuredPassportDate);
                        params.insuredPassportDate= Date.parse(date5)
                        params.insuredPassportDate = params.insuredPassportDate / 1000;
                    }
                    /*if(params.ownerDob!=null&&params.ownerDob!=''&&params.ownerDob!=undefined){
                        params.ownerDob = params.ownerDob / 1000;
                    }*/
                    if(params.ownerIdNoDate!=null&&params.ownerIdNoDate!=''&&params.ownerIdNoDate!=undefined){
                        var date2 = new Date(params.ownerIdNoDate);
                        params.ownerIdNoDate= Date.parse(date2)
                        params.ownerIdNoDate = params.ownerIdNoDate / 1000;
                    }
                    if(params.ownerPassportDate!=null&&params.ownerPassportDate!=''&&params.ownerPassportDate!=undefined){
                        var date4 = new Date(params.ownerPassportDate);
                        params.ownerPassportDate= Date.parse(date4)
                        params.ownerPassportDate = params.ownerPassportDate / 1000;
                    }
                    if(params.beneficiary1Dob==null||params.beneficiary1Dob==''||params.beneficiary1Dob==undefined){
                        //params.beneficiary1Dob = params.beneficiary1Dob / 1000;
                        delete params.beneficiary1Dob;
                    }
                    if(params.beneficiary2Dob==null||params.beneficiary2Dob==''||params.beneficiary2Dob==undefined){
                        //params.beneficiary2Dob = params.beneficiary2Dob / 1000;
                        delete params.beneficiary2Dob;
                    }
                    if(params.beneficiary3Dob==null||params.beneficiary3Dob==''||params.beneficiary3Dob==undefined){
                        //params.beneficiary3Dob = params.beneficiary3Dob / 1000;
                        delete params.beneficiary3Dob;
                    }


                    params.insuredAsOwner =  params.insuredAsOwner==true?1:0;
                    params.isSavings =  params.isSavings==true?1:0;
                    params.isSalaryIncome =  params.isSalaryIncome==true?1:0;
                    params.isSelfIncome =  params.isSelfIncome==true?1:0;
                    params.isInvestIncome =  params.isInvestIncome==true?1:0;
                    params.isSaleOfAsset =  params.isSaleOfAsset==true?1:0;
                    params.sourcesOther =  params.sourcesOther==true?1:0;
                    params.isProtection =  params.isProtection==true?1:0;
                    params.isEtFund =  params.isEtFund==true?1:0;
                    params.isSavingInvest =  params.isSavingInvest==true?1:0;
                    params.isRetirement =  params.isRetirement==true?1:0;
                    params.isKeyMan =  params.isKeyMan==true?1:0;
                    params.isEstate =  params.isEstate==true?1:0;
                    params.purposeOthers =  params.purposeOthers==true?1:0;
                    if(params.overseaRiderList.length>0){
                        params.overseaRiderListStr = JSON.stringify(params.overseaRiderList,
                            ["id","overseaId","productId","productPeriodId","sumInsured","premium"]);
                    }


                    if(params.questionOne.length>0){
                        let list1 =[];
                        params.questionOne.forEach(v=>{
                            if(list1.length==0){
                                list1.push(v);
                            }else{
                                let isNew=false;
                                list1.forEach(k=>{
                                    if(k==v){
                                        isNew=false;
                                    }else{
                                        isNew=true;
                                    }
                                })
                                if(isNew){
                                    list1.push(v)
                                }
                            }
                        });
                        let str ="";
                        list1.forEach(v=>{
                            str +=v+",";
                        })
                        str=str.substring(0,str.length-1);
                        params.questionOne = str;
                    }
                    if(params.questionTwo.length>0){
                        let list1 =[];
                        params.questionTwo.forEach(v=>{
                            if(list1.length==0){
                                list1.push(v);
                            }else{
                                let isNew=false;
                                list1.forEach(k=>{
                                    if(k==v){
                                        isNew=false;
                                    }else{
                                        isNew=true;
                                    }
                                })
                                if(isNew){
                                    list1.push(v)
                                }
                            }
                        });
                        let str ="";
                        list1.forEach(v=>{
                            str +=v+",";
                        })
                        str=str.substring(0,str.length-1);
                        params.questionTwo = str;
                    }



                    delete params.id;
                    delete params.overseaRiderList;
                    delete params.productOption;
                    delete params.productPeriodOption;
                    delete params.uploadFileList;
                    if(this.pdfName2==null || this.pdfName2=='' || this.pdfName2==undefined){
                        params.tableName2Insured=0;
                    }
                    if(this.pdfName3==null || this.pdfName3=='' || this.pdfName3==undefined){
                        params.tableName3Insured=0;
                    }
                    insertOverseaApplication(params).then(res=>{
                        if(res.errcode==200){
                            this.state=true
                            sessionStorage.removeItem('overseaApplication')
                            sessionStorage.removeItem('list')
                            this.$toast({
                                message: '新增成功',
                                iconClass:'icon icon-success'
                            });
                            this.$router.push('/mobile/mobOverseaApp')

                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    });
                }

            },
            onOwnerPersonalHealthChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.ownerPersonalHealth=values[0]
                    this.overseaApplication.ownerPersonalHealth=this.healthOption.find(v=>v.label==values[0]).value
                }else {
                    this.ownerPersonalHealth='請選擇'
                    this.overseaApplication.ownerPersonalHealth=''
                }
            },
            onPersonalHealthChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.PersonalHealth=values[0]
                    this.overseaApplication.insuredPersonalHealth=this.healthOption.find(v=>v.label==values[0]).value
                }else {
                    this.PersonalHealth='請選擇'
                    this.overseaApplication.insuredPersonalHealth=''
                }
            },
            isMedicalChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.isMedical=values[0]
                    if(this.isMedical=='是'){
                        this.overseaApplication.isMedical=1
                    }else {
                        this.overseaApplication.isMedical=0
                    }
                }else {
                    this.isMedical=='否'
                    this.overseaApplication.isMedical=0
                }

            },
            onOwnerFamilyHealthChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.ownerFamilyHealth=values[0]
                    this.overseaApplication.ownerFamilyHealth=this.healthOption.find(v=>v.label==values[0]).value
                }else {
                    this.ownerFamilyHealth='請選擇'
                    this.overseaApplication.ownerFamilyHealth=''
                }
            },
            onFamilyHealthChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.FamilyHealth=values[0]
                    this.overseaApplication.insuredFamilyHealth=this.healthOption.find(v=>v.label==values[0]).value
                }else {
                    this.FamilyHealth='請選擇'
                    this.overseaApplication.insuredFamilyHealth=''
                }
            },
            onOwnerSexChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.ownerSex=values[0]
                    if(values[0]=='男'){
                        this.overseaApplication.ownerSex=0
                    }else {
                        this.overseaApplication.ownerSex=1
                    }
                }else {
                    this.ownerSex='請選擇'
                    this.overseaApplication.ownerSex=''
                }
            },
            onInsuredSexChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.insuredSex=values[0]
                    if(values[0]=='男'){
                        this.overseaApplication.insuredSex=0
                    }else {
                        this.overseaApplication.insuredSex=1
                    }
                }else {
                    this.insuredSex='請選擇'
                    this.overseaApplication.insuredSex=''
                }
            },
            onOwnerEducationChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.ownerEducation=values[0]
                    this.overseaApplication.ownerEducation=this.educationOption.find(v=>v.label==values[0]).value
                }else {
                    this.ownerEducation='請選擇'
                    this.overseaApplication.ownerEducation=''
                }
            },
            onEducationChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.education=values[0]
                    this.overseaApplication.insuredEducation=this.educationOption.find(v=>v.label==values[0]).value
                }else {
                    this.education='請選擇'
                    this.overseaApplication.insuredEducation=''
                }
            },
            onOwnerIsUsChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.ownerIsUs=values[0]
                    if(values[0]=='是'){
                        this.overseaApplication.ownerIsUs=1
                    }else {
                        this.overseaApplication.ownerIsUs=0
                    }
                }else {
                    this.ownerIsUs='請選擇'
                    this.overseaApplication.ownerIsUs=''
                }
            },
            oninsuredIsUsChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.insuredIsUs=values[0]
                    if(values[0]=='是'){
                        this.overseaApplication.insuredIsUs=1
                    }else {
                        this.overseaApplication.insuredIsUs=0
                    }
                }else {
                    this.insuredIsUs='請選擇'
                    this.overseaApplication.insuredIsUs=''
                }
            },
            onOwnerIsHkChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    if(values[0]=='香港永久居民'){
                        this.ownerIsHk=values[0]
                        this.overseaApplication.ownerIsHk=1
                    }else {
                        this.ownerIsHk=values[0]
                        this.overseaApplication.ownerIsHk=0
                    }
                }else {
                    this.ownerIsHk='請選擇'
                    this.overseaApplication.ownerIsHk=''
                }


            },
            onIsHkChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    if(values[0]=='香港永久居民'){
                        this.insuredIsHk=values[0]
                        this.overseaApplication.insuredIsHk=1
                    }else {
                        this.insuredIsHk=values[0]
                        this.overseaApplication.insuredIsHk=0
                    }
                }else {
                    this.insuredIsHk='請選擇'
                    this.overseaApplication.insuredIsHk=''
                }


            },
            onMaritalChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.maritalName=values[0]
                    this.overseaApplication.insuredMarital=this.maritalOption.find(v=>v.label==values[0]).value
                }else {
                    this.maritalName='請選擇'
                    this.overseaApplication.insuredMarital=''
                }
            },
            onOwnerMaritalChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.ownerMarital=values[0]
                    this.overseaApplication.ownerMarital=this.maritalOption.find(v=>v.label==values[0]).value
                }else {
                    this.ownerMarital='請選擇'
                    this.overseaApplication.ownerMarital=''
                }
            }
            ,
            onProductChange(picker, values){

                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].name=values[0]
                    this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productId=this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productOption.find(v=>(v.nameCn+' ('+v.nameEng+')')==values[0]).id
                    let params={productId: this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productId}
                    queryProductPeriodOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productPeriodOption=[]}=res;
                            this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productPeriodOption=productPeriodOption;

                            let arr=[]
                            arr.push('請選擇')
                            productPeriodOption.filter(v=>{
                                arr.push(v.periodName)
                            })
                            this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productPeriodSolts=[]
                            this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productPeriodSolts.push({values:arr})
                            this.fnaAnswerSelected()
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductRiderPeriodOption Error");
                    });

                }else {
                    if(this.currencyOverseaRiderIndex!=''){
                        this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].name='請選擇'
                        this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productId=''
                    }
                }
            },
            getProductSlots(){
                this.productSolts=[]
                this.productOption2= this.overseaApplication.riderOption
                let arr=[]
                arr.push('請選擇')
                this.overseaApplication.riderOption.filter(v=>{
                    arr.push(v.nameCn+' ('+v.nameEng+')')
                })
                this.productSolts.push({values:arr})
            },
            aa(){

            },
            onPayTermChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.payTermName=values[0]
                    this.overseaApplication.payTerm=this.payTermOption.find(v=>v.label== values[0]).value
                }else {
                    this.payTermName='請選擇'
                    this.overseaApplication.payTerm=''
                }
            },
            onCurrencyChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.currencyName=values[0]
                    this.overseaApplication.currencyId=this.currencyOption.find(v=>v.name== values[0]).id
                }else {
                    this.currencyName='請選擇'
                    this.overseaApplication.currencyId=''
                }
            },
            queryCurrencyOption(){
                this.currencySolts=[]
                return queryCurrencyOption().then(res=>{
                    if(res.errcode==200){
                        let {data:currencyOption=[]}=res;
                        this.currencyOption=currencyOption;
                        let arr=[]
                        arr.push('請選擇')
                        this.currencyOption.filter(v=>{
                            arr.push(v.name)
                        })
                        this.currencySolts.push({values:arr})
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryCurrencyOption Error");
                });
            },
            onRiderChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.riderName=values[0]
                    this.overseaApplication.periodId=this.overseaApplication.productPeriodOption.find(v=>v.periodName==values[0]).id
                }else {
                    this.riderName='請選擇'
                    this.overseaApplication.periodId=''
                }
            },
            onRiderChange2(picker, values){
                if(values[0]!=undefined&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].riderName=values[0]
                    this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productPeriodId=this.overseaApplication.overseaRiderList[this.currencyOverseaRiderIndex].productPeriodOption.find(v=>v.periodName==values[0]).id
                }
            },
            checkForm(){
                if(this.overseaApplication.mcvDate===''||this.overseaApplication.mcvDate==null){
                    this.openMesg()
                    return
                }
                if(this.overseaApplication.mcvTime===''||this.overseaApplication.mcvTime==null){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.partnerId===''||  this.overseaApplication.partnerId==null){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.policyRegion==null|| this.overseaApplication.policyRegion===''){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.insuranceId==null|| this.overseaApplication.insuranceId===''){
                    this.openMesg()
                    return
                }
                if(  this.overseaApplication.currencyId==null||  this.overseaApplication.currencyId===''){
                    this.openMesg()
                    return
                }
                if(this.overseaApplication.productId==null|| this.overseaApplication.productId===''){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.periodId==null||  this.overseaApplication.periodId===''){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.currencyId==null|| this.overseaApplication.currencyId===''){
                    this.openMesg()
                    return
                }

                if( this.overseaApplication.payTerm==null|| this.overseaApplication.payTerm===''){
                    this.openMesg()
                    return
                }
                if(  this.overseaApplication.isLoan==null||   this.overseaApplication.isLoan===''){
                    this.openMesg()
                    return
                }
                let state=false
                if(this.overseaApplication.overseaRiderList.length!=0){
                    this.overseaApplication.overseaRiderList.filter(v=> {
                        if(v.productId===''||v.productId==null||v.productPeriodId===''||v.productPeriodId==null){
                            state=true
                        }
                    })
                }
                if(state){
                    this.openMesg()
                    return
                }
                if(this.overseaApplication.insuredMarital==null||this.overseaApplication.insuredMarital===''){
                    this.openMesg()
                    return
                }
                if(  this.overseaApplication.insuredIsHk==null||  this.overseaApplication.insuredIsHk===""){
                    if(this.overseaApplication.insuredIsHk==0){

                    }else {
                        this.openMesg()
                        return
                    }
                }
                if(   this.overseaApplication.insuredIsUs==null||    this.overseaApplication.insuredIsUs===''){
                    this.openMesg()
                    return
                }


                if(this.overseaApplication.insuredSex==null|| this.overseaApplication.insuredSex===''){
                    this.openMesg()
                    return
                }
                if(this.overseaApplication.insuredFamilyHealth==null|| this.overseaApplication.insuredFamilyHealth===''){
                    this.openMesg()
                    return
                }

                if( this.overseaApplication.insuredPersonalHealth==null||this.overseaApplication.insuredPersonalHealth===""){
                    this.openMesg()
                    return
                }



                if( this.overseaApplication.insuredMedicalHist==null||  this.overseaApplication.insuredMedicalHist===''){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.insuredHospitalHist==null||  this.overseaApplication.insuredHospitalHist===''){
                    this.openMesg()
                    return
                }
                if( this.overseaApplication.insuredTreatment==null||  this.overseaApplication.insuredTreatment===''){
                    this.openMesg()
                    return
                }

                if(this.overseaApplication.insuredAsOwner){
                    if(  this.overseaApplication.ownerMarital==null||   this.overseaApplication.ownerMarital===''){
                        this.openMesg()
                        return
                    }

                    if( this.overseaApplication.ownerIsHk==null|| this.overseaApplication.ownerIsHk===''){
                        this.openMesg()
                        return
                    }
                    if(this.overseaApplication.ownerIsUs==null||this.overseaApplication.ownerIsUs===''){
                        this.openMesg()
                        return
                    }
                    if(this.overseaApplication.ownerSex==null||this.overseaApplication.ownerSex===''){
                        this.openMesg()
                        return
                    }
                    if( this.overseaApplication.ownerFamilyHealth==null|| this.overseaApplication.ownerFamilyHealth===''){
                        this.openMesg()
                        return
                    }
                    if( this.overseaApplication.ownerPersonalHealth==null||this.overseaApplication.ownerPersonalHealth===''){
                        this.openMesg()
                        return
                    }

                    if( this.overseaApplication.ownerMedicalHist==null||this.overseaApplication.ownerMedicalHist===''){
                        this.openMesg()
                        return
                    }
                    if( this.overseaApplication.ownerHospitalHist==null||this.overseaApplication.ownerHospitalHist===''){
                        this.openMesg()
                        return
                    }
                    if( this.overseaApplication.ownerTreatment==null||this.overseaApplication.ownerTreatment===''){
                        this.openMesg()
                        return
                    }


                }
                this.overseaApplicationSave()
            },
            onOverseaAppChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.overseaAppName=values[0]
                    this.overseaApplication.productId= this.overseaApplication.productOption.find(v=>(v.nameCn+' ('+v.nameEng+')')==this.overseaAppName).id
                    let params ={productId:this.overseaApplication.productId};
                    this.riderSolts=[]
                    this.pdfName2="";
                    this.pdfName3="";
                    queryProductPeriodOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productPeriodOption=[]}=res;
                            let a = this.overseaApplication.productOption.find(v=>v.id==this.overseaApplication.productId);
                            this.pdfName2 = a.pdfName2;
                            this.pdfName3 = a.pdfName3;
                            this.overseaApplication.productPeriodOption=productPeriodOption;
                            let arr=[]
                            arr.push('請選擇')
                            this.overseaApplication.productPeriodOption.filter(v=>{
                                arr.push(v.periodName)
                            })
                            this.riderSolts.push({values:arr})
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductPeriodOption Error");
                    });

                }else {
                    this.overseaAppName='請選擇'
                    this.overseaApplication.productId=''
                    this.riderSolts=[]
                }
            },
            onInsuranceChange(picker, values){
                if(values[0]!=''&&values[0]!=null&&values[0]!='請選擇'&&values[0]!=undefined){
                    this.insuranceName=values[0]
                    this.overseaAppSolts=[]
                    this.riderSolts=[]
                    this.overseaAppName=''
                    this.riderName=''
                    this.overseaApplication.insuranceId=this.insuranceOption.find(v=>v.nameEng==values[0]).id
                    queryProductByInsuranceId(this.overseaApplication.insuranceId).then(res=>{
                        if(res.errcode==200){
                            let {data:productOption=[]}=res;
                            this.overseaApplication.productOption=productOption[0];
                            let arr=[]
                            arr.push('請選擇')
                            this.overseaApplication.productOption.filter(v=>{
                                let val=v.nameCn+' ('+v.nameEng+')'
                                arr.push(val)
                            })
                            this.overseaAppSolts.push({values:arr})
                            this.overseaApplication.riderOption=productOption[1];
                            this.getProductSlots()

                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductOption Error");
                    });

                }else {
                    this.insuranceName='請選擇'
                    this.overseaApplication.insuranceId=''
                }
            },
            queryInsuranceOption(){
                return queryInsuranceOption().then(res=>{
                    if(res.errcode==200){
                        let {data:insuranceOption=[]}=res;
                        this.insuranceOption=insuranceOption;
                        let arr=[]
                        arr.push('請選擇')
                        this.insuranceOption.filter(v=>{
                            arr.push(v.nameEng)
                        })
                        this.insuranceSolts=[]
                        this.insuranceSolts.push({values:arr})
                        //

                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });

                    }
                }).catch((error)=>{
                    console.log("queryInsuranceOption Error");
                });
            },
            queryPartnerOption(){
                let partner = {id:this.$store.getters.staff.id,nameChi:this.$store.getters.staff.name};
                this.partnerName=this.$store.getters.staff.name
                this.overseaApplication.partnerId=this.$store.getters.staff.id
            },
            changeCollsapce2(key){
                if(this.styleList2[key]==false){
                    this.styleList2[key]=true
                    this.$set(  this.styleList2,key,true)
                    for(let a=0;a<this.styleList2.length;a++){
                        if(a!=key){
                            this.styleList2[a]=false
                        }
                    }
                }else {
                    this.styleList2[key]=false
                    this.$set(  this.styleList2,key,false)
                }
            },
            changeCollsapce(key){
                if(this.styleList[key]==false){
                    this.styleList[key]=true
                    this.$set(  this.styleList,key,true)
                    for(let a=0;a<this.styleList.length;a++){
                        if(a!=key){
                            this.styleList[a]=false
                        }
                    }
                }else {
                    this.styleList[key]=false
                    this.$set(  this.styleList,key,false)
                }
            },
            delOverseaRider(){
                this.overseaApplication.overseaRiderList.splice(this.currencyOverseaRiderIndex,1)
            },
            createOverseaRider(){
                let productSolts=[]
                this.productOption2= this.overseaApplication.riderOption
                let arr=[]
                arr.push('請選擇')
                if(this.overseaApplication.riderOption!=undefined){
                    this.overseaApplication.riderOption.filter(v=>{
                        arr.push(v.nameCn+' ('+v.nameEng+')')
                    })
                }
                productSolts.push({values:arr})

                if(this.overseaApplication.overseaRiderList.length>4){
                    return this.$message.error("最多添加5個附加計劃");
                }

                this.overseaApplication.overseaRiderList.push({
                    name:'',
                    id:null,overseaId:this.overseaApplication.id,productId:'',riderName:'',productPeriodId:'',sumInsured:0,premium:0,productSolts:productSolts, productOption:this.overseaApplication.riderOption,productPeriodOption:[],  productPeriodSolts:[],
                });
                this.currencyOverseaRiderIndex= this.overseaApplication.overseaRiderList.length-1
                if(  this.overseaApplication.overseaRiderList.length==1){
                    this.styleList.push(true)
                }else {
                    this.styleList.push(false)
                }

            },
            onValuesChange(picker, values) {
                this.value2 = values[0];
                //
                if(this.value2==''||this.value2=='請選擇'||this.value2==undefined){
                    this.value2='请选择'
                    this.overseaApplication.policyRegion=''
                }else {
                    if(this.value2=='香港'){
                        this.overseaApplication.policyRegion=1
                    }else {
                        this.overseaApplication.policyRegion=2
                    }
                }
            }
            ,
            onPartnerChange(picker, values){
                let  value= values[0];
                if(value=='請選擇'||value==null||value==''||value==undefined){
                    this.overseaApplication.partnerId=''
                    this.partnerName='請選擇'
                }else {
                    this.partnerName=value
                    this.overseaApplication.partnerId=this.$store.getters.staff.id
                }
            },
            openPicker() {
                this.$refs.picker.open();
            },
            onChange(){
                this.active='tab-container3'
            }
        }
    }
</script>
<style scoped>
    .import::before {
        content: '* ';
        color: red;

        position: absolute;
        left: 1px;
        top: 17px;
    }
    .other_box:nth-child(1){
        border-top: 1px solid gainsboro;
    }
    .other_box{
        border-bottom:1px solid gainsboro;
        /*padding:5px 0px;*/
    }
    .other_box{
        padding: 10px 0px;
    }
    .mint-field{
        vertical-align: middle;
    }
    .mint-cell-value.is-link{
        margin-right: 120px!important;
    }
    .icon-jia{
        color: #00b3ee;
        font-size:30px;
        position: absolute;
        top:15px;
        z-index: 888;
        left:0px;
    }
    .content_text div{
        padding:0.15rem 0rem!important;
    }
    .content_text div p{
        display: inline-block;
    }
    .content_text div p:nth-child(1){
        width:30%;
    }
    .content_text div p:nth-child(2){
        width: 68%;
    }
    .collsapce{
        height:0px;
        display: none;
        transition: all 0.5s;
    }
    .cell {
        display: block;
        height: 238px;
        transition: all 0.5s;
    }
    .other_cls p{
        padding: 8px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/views/mobile/bookingApplication.vue